const API_KEY = process.env.VUE_APP_GOOGLE_API_KEY
import axios from 'axios'

export const getGeoLocation = {
  methods: {
    getGeoLocationfromPostal(postal) {
      return axios.get('https://maps.googleapis.com/maps/api/geocode/json?address=' + postal + '&key=' + API_KEY + '&region=NL')
        .then(response => {
          return response
        })
        .catch(e => {
          console.log("There was an error: " + e);
        })
    }
  },
}
